import type { ShadowInputElement, ShadowInputRef } from './types';

const handleActiveFocus = (inputRef: ShadowInputRef) => {
  if (inputRef?.current) {
    const { shadowRoot } = inputRef.current;
    const inputElement = shadowRoot.querySelector('#fuel-input') as ShadowInputElement;
    if (inputElement) {
      setTimeout(() => {
        inputElement.focus();
      }, 500);
    }
  }
};

export { handleActiveFocus };
